<template>

  <!--Page Header ends -->
  <!-- Main sign-up section starts -->
  <section id="ourfaq" class="bglight position-relative padding">
    <div class="container">
      <div class="row">
        <router-view></router-view>
        <div class="col-lg-6 d-none d-lg-block pl-lg-0">
          <div class="image login-image h-100">
            <img src="/img/auth-bg.png" alt="" />
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-md-12">
         
        </div>
      </div> -->
    </div>
  </section>
</template>